import Parser from 'rss-parser'

const fetchRss = (url) => {
  const parser = new Parser()

  return fetch(url, {method: "GET", mode: "cors"})
    .then(response => response.text())
    .then(text => parser.parseString(text))
}

export {
  fetchRss
}
